import * as React from 'react';
import { BlogEditorReadOnlyWithStylesWithoutStore } from '@doltech/ui/lib/figma/BlogEditor/BlogEditorReadOnlyWithStylesPlugin';

interface ConclusionPreviewProps {
  detailData: any;
}

export const ConclusionPreview = ({ detailData }: ConclusionPreviewProps) => {
  const conclusionValue = React.useMemo(() => {
    if (detailData?.conclusion) {
      return {
        ...detailData.conclusion,
        content:
          typeof detailData.conclusion?.content === 'string'
            ? JSON.parse(detailData.conclusion?.content)
            : detailData.conclusion?.content,
      };
    }
    return null;
  }, [detailData]);

  if (conclusionValue) {
    return (
      <BlogEditorReadOnlyWithStylesWithoutStore isReadOnly initialValue={conclusionValue.content} />
    );
  }
  return null;
};
